import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import ChildLogin from "./pages/ChildLogin";
import StaffLogin from "./pages/StaffLogin";
import ChildHome from "./pages/ChildHome";
import ModulePage from "./pages/ModulePage";
import SessionPlayer from "./pages/SessionPlayer";
import ChildQuests from "./pages/ChildQuests";
import ChildBadges from "./pages/ChildBadges";
import ChildNotices from "./pages/ChildNotices";
import Privacy from "./pages/Privacy";
import SignupWizard from "./pages/SignupWizard";
import VerifyEmail from "./pages/VerifyEmail";
import LearnPage from "./pages/LearnPage";
import DiagnosticPage from "./pages/DiagnosticPage";
import PitchTrainerPage from "./pages/PitchTrainerPage";
import StaffLayout from "./staff/StaffLayout";
import StaffDashboard from "./staff/StaffDashboard";
import ChoristersPage from "./staff/ChoristersPage";
import ChoristerDetail from "./staff/ChoristerDetail";
import QuestsPage from "./staff/QuestsPage";
import ModulesPage from "./staff/ModulesPage";
import ReportsPage from "./staff/ReportsPage";
import CurriculumPage from "./staff/CurriculumPage";
import CertificatesPage from "./staff/CertificatesPage";
import LoginCards from "./staff/LoginCards";
import SuperAdmin from "./staff/SuperAdmin";
import ContentPage from "./staff/ContentPage";
import "@/App.css";

function Guard({ kind, children }) {
  const { session } = useAuth();
  const location = useLocation();
  if (session === undefined) return null;
  if (!session || session.kind !== kind) {
    return <Navigate to={kind === "staff" ? "/staff" : "/play"} state={{ from: location }} replace />;
  }
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-center" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/play" element={<ChildLogin />} />
          <Route path="/staff" element={<StaffLogin />} />
          <Route path="/signup" element={<SignupWizard />} />
          <Route path="/staff/verify" element={<VerifyEmail />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/play/home" element={<Guard kind="chorister"><ChildHome /></Guard>} />
          <Route path="/play/module/:moduleId" element={<Guard kind="chorister"><ModulePage /></Guard>} />
          <Route path="/play/learn/:topicId" element={<Guard kind="chorister"><LearnPage /></Guard>} />
          <Route path="/play/diagnostic" element={<Guard kind="chorister"><DiagnosticPage /></Guard>} />
          <Route path="/play/session" element={<Guard kind="chorister"><SessionPlayer /></Guard>} />
          <Route path="/play/quests" element={<Guard kind="chorister"><ChildQuests /></Guard>} />
          <Route path="/play/badges" element={<Guard kind="chorister"><ChildBadges /></Guard>} />
          <Route path="/play/notices" element={<Guard kind="chorister"><ChildNotices /></Guard>} />
          <Route path="/play/pitch-trainer" element={<Guard kind="chorister"><PitchTrainerPage /></Guard>} />
          <Route path="/staff" element={<Guard kind="staff"><StaffLayout /></Guard>}>
            <Route path="dashboard" element={<StaffDashboard />} />
            <Route path="choristers" element={<ChoristersPage />} />
            <Route path="choristers/:id" element={<ChoristerDetail />} />
            <Route path="quests" element={<QuestsPage />} />
            <Route path="curriculum" element={<CurriculumPage />} />
            <Route path="modules" element={<ModulesPage />} />
            <Route path="content" element={<ContentPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="certificates" element={<CertificatesPage />} />
            <Route path="login-cards" element={<LoginCards />} />
          </Route>
          <Route path="/super" element={<Guard kind="staff"><SuperAdmin /></Guard>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
